export default __webpack_public_path__ + "static/media/Pollution-lumineuse.0b889185.svg";